import { StyleSheet, Text, View } from '@react-pdf/renderer';
import type { LightInvoiceFixedLineItem } from '@weft/api-definition';
import { formatPrice } from '@weft/services';
import type { Currency } from '@weft/types';
import { isNotEmptyString, withDefault } from '@weft/utils';
import React from 'react';

const styles = StyleSheet.create({
  container: {
    borderBottomWidth: '1px',
    borderBottomColor: '#E8F2F8',
    paddingHorizontal: '17px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    gap: '3px',
    paddingVertical: '9px',
  },
  namePriceContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  name: {
    fontSize: '14px',
    color: '#292D32',
    fontWeight: 500,
  },
  description: {
    fontSize: '12px',
    fontWeight: 400,
    color: '#A3ACBD',
  },
  price: {
    fontSize: '14px',
    color: '#292D32',
    fontWeight: 500,
    fontFamily: 'Inter',
  },
});

type FixedProductLineItemProps = {
  fixedLineItem: LightInvoiceFixedLineItem;
  currency: Currency;
};

export const FixedProductLineItem: React.FC<FixedProductLineItemProps> = ({ fixedLineItem, currency }) => {
  const name = withDefault(fixedLineItem.modifiedName, fixedLineItem.productName);

  return (
    <View
      style={styles.container}
      wrap={false}
    >
      <View style={styles.namePriceContainer}>
        <Text style={styles.name}>{name}</Text>
        <Text style={styles.price}>{formatPrice(fixedLineItem.price, currency)}</Text>
      </View>

      {isNotEmptyString(fixedLineItem.description) && (
        <Text style={styles.description}>
          {fixedLineItem.description}
        </Text>
      )}
    </View>
  );
};